import type { SitewideValues } from '@snapchat/mw-contentful-schema';
import { createContext } from 'react';

export interface SitewideConfigurationContextProps {
  sitewideValues?: SitewideValues;
}

export const SitewideConfigurationContext = createContext<SitewideConfigurationContextProps>({});
